export default "<mat-form-field>\n  <input (ngModelChange)=\"changeValue($event)\" [ngModel]=\"rule.value\" matInput type=\"text\">\n</mat-form-field>\n";